module.exports = `<!DOCTYPE html>

<html>

<head>
    <title>Diagram</title>
    <link type="text/css" rel="stylesheet" href="./jquery.qtip.min.css" />
    <link type="text/css" rel="stylesheet" href="./jquery.growl.css" />
    <link type="text/css" rel="stylesheet" href="./jquery-confirm.min.css" />
    <link type="text/css" rel="stylesheet" href="./displaymodel.css" />
</head>

<body>
    <h1>Order Diagram Page</h1>
    <div id="bpmnModel"></div>
    <script type="text/javascript"
        src="./jquery-1.12.4.min.js"></script>
    <script type="text/javascript"
        src="./jquery.qtip.min.js"></script>
    <script type="text/javascript"
        src="./jquery.growl.js"></script>
    <script type="text/javascript"
        src="./jquery-confirm.min.js"></script>
    <script type="text/javascript"
        src="./raphael.min.js"></script>
    <script type="text/javascript"
        src="./bpmn-draw.js"></script>
    <script type="text/javascript"
        src="./bpmn-icons.js"></script>
    <script type="text/javascript"
        src="./Polyline.js"></script>
    <script type="text/javascript"
        src="./diagram.js"></script>
</body>

    <style>

    </style>

</html> `;
